
import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL, ucwords } from '../../settings/common';
import { seo } from '../../settings/seo';
import { Validation } from '../../helpers/validation';
import { encrypt } from '../../helpers/encryption';
import WAServices from '../../services/WAServices';
import { AppContext } from '../../helpers/AppContext';
import { Overlay } from '../../helpers/Overlay';
import { showSuccessMessage, showErrorMessage } from '../../helpers/flash-messages';


const LoginPage = () => {
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const { setSharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();
    const waServices = new WAServices();
    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Login',
            metaDescription: '',
        });
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value,
        };
        setFormData(newFormData);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = Validation(formData,['business_phone_number']);
        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        submitForm();
    };

    const submitForm = async () => {
        setLoading(true);
        try {
            waServices.login(formData).then(response => {
                setLoading(false);
                if(typeof response !== 'undefined') {
                    const data = response.data;
                    if(data.status === 'success') {
                        encrypt(data.data, '__bs_auth_user');
                        //localStorage.setItem('__bs_auth_user', JSON.stringify(data.data));
                        setSharedAuthUser(data.data);
                        showSuccessMessage('Login successfully.');
                        navigate(INDEX_URL+'chat-list');
                    } else {
                        showErrorMessage(`${data.message}`)
                    }
                } else {
                    showErrorMessage('Server error: Something went wrong. Please try again later.');
                }
            });
        } catch (error) {
            setLoading(false);
            // Check for server-side error (500)
            if (error.response && error.response.status === 500) {
                showErrorMessage('Server error: Something went wrong. Please try again later.');
            } else {
                // Handle other types of errors, such as network errors
                showErrorMessage('An error occurred. Please check your connection and try again.');
            }
        }
    }

    const renderLoginForm = () => {
        return(
            <React.Fragment>
                <form className="cx-form" onSubmit={handleSubmit}>
                    <h4>Login</h4>
                    <div className="input-control">
                        <input type="text" placeholder="Enter phone numer" name="business_phone_number" value={formData.business_phone_number || ''} onChange={handleChange}/>
                        {errors.business_phone_number && <div className="text-danger">{errors.business_phone_number}</div>}
                    </div>
                    <div className="form-btns">
                        <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Login'}</button>
                    </div>

                </form>
            </React.Fragment>
        )
    }
    return (
        <React.Fragment>
        <main className="wrapper">
            <section className="auth-section">
                <div className="cx-left">
                    <div className="cx-bg"></div>
                </div>
                <div className="cx-right">
                    <div className="cx-form-page">
                        {/* <!-- Login form --> */}
                        {renderLoginForm()}
                    </div>
                </div>
		    </section>
            {/* Show loading overlay when `loading` is true */}
            {loading && (
                <Overlay />
            )}
	    </main>
    </React.Fragment>
    );
};
                
export default LoginPage;